
import * as ReactDOM from 'react-dom';
import { Main } from './Logic/Main'
import { Navigated } from './Logic/Router/Router'

import 'bootstrap/dist/css/bootstrap.css'
// import 'font-awesome/css/font-awesome.min.css'
import './Assets/style.css'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
// import * as Common from './import/WebSocket'
// import {Logic} from './Logic/Type'
// export let Cli = new Common.Net.modules.WebSocketServer.WebSocketClient('89.212.50.250',10100)
// const path = 'points'
// const method = 'get'
// const input =  {query:{player: 'roki321'}}
// const key = '30e73b7e1f2e3a24a941052f4e970f2c'
// const login = JSON.stringify({[path]: {method, input, key}})
// console.log(login)
// Cli.Connect((socket) => {
//     console.log('Client Connected')
//     socket.Send(Common.Text.Unicode.Binary(login))
//     socket.Read(async (data) => {
//         const p = Common.Text.Unicode.String(data)
//         if (p === 'ping') {
//             alert ('changed')
//         } else {
//             const parse = JSON.parse(p)
//             Logic.Type.New (Main.Instance.IndexState, {data: parse})
//         }
//     })
// })
// import {Index} from './Views/Main/Index/Index'

function setCookies() {
    let location = readCookie('location')

    let username = readCookie('username')
    // let mail = readCookie('mail')

    if(!Main.Instance.Location) {
        Main.Instance.Location = location
    }

    Main.Instance.LoginState.Verified = true
    Main.Instance.LoginState.Username = username
    // Main.Instance.LoginState.Mail = mail
}

function getTime() {

    var now = new Date()
    return now.getTime()
}

function readCookie(name:string) {

    var nameEQ = name + '='
    var ca = document.cookie.split(';')

    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1,c.length)
        }

        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length,c.length)
        }
    }

    return null
}

Main.Instance = new Main(new class {
    Update(state: Main): void {

        Main.Instance = state

        let usr1 = readCookie('username')
        let loc1 = readCookie('location')
        // let rl1 = readCookie('mail')
        let exp1 = readCookie('expires')
        if (loc1 && usr1 && /*rl1 &&*/ exp1) {

            if (parseInt(exp1,10) > getTime()) {
                setCookies()
            }
        }

        window.history.replaceState(Main.Instance.Location, Main.Instance.Location, Main.Instance.Location)

        // ReactDOM.render(<Index/>, document.getElementById('root'))
        ReactDOM.render(Navigated(Main.Instance), document.getElementById('root'))
    }
})

Main.Instance.Location = window.location.pathname

let usr = readCookie('username')
// let rl = readCookie('mail')

let loc = readCookie('location')
let exp = readCookie('expires')
if(loc && usr /*&& rl*/ && exp) {

    if(parseInt(exp, 10) > getTime()) {
        setCookies()
    }
}

ReactDOM.render(Navigated(Main.Instance), document.getElementById('root'))


// WEBPACK FOOTER //
// ./src/index.tsx